/**
 * Sanitizes header values to ensure they are Firefox/RFC compliant (Latin-1 only).
 * Removes characters outside the ISO-8859-1 range and trims whitespace/newlines.
 */
const sanitizeHeader = (value: string | undefined | null): string => {
  if (!value) return '';
  // Remove any character that is not in the printable ASCII range (plus some Latin-1)
  // This regex matches characters NOT in the range of space (32) to ~ (126)
  // We can be strict or allow extended Latin-1 (\x00-\xFF).
  // Safest for HTTP headers is printable ASCII + trim.
  return String(value)
    .replace(/[^\x20-\x7E]/g, '')
    .trim();
};

export default sanitizeHeader;
